import {createSelector} from 'reselect'
import {selectPanels} from '../selector'

export const selectUserPanel = createSelector(
    selectPanels,
    (panels) => panels.user
)


// WEBPACK FOOTER //
// ./web/js/panels/user/selector.js